class RecipientForm extends HTMLElement {
  constructor() {
    super();

    // Scope elements
    this.form = this.querySelector('[data-recipient-form]');
    this.productForm = document.querySelector('product-form');

    // Bind events
    this.bindEvents();
  }

  /**
   * Bind events
   */
  bindEvents() {
    this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  /**
   * Handle form submit
   * @param {Event} event
   */
  handleFormSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const filteredFormData = {};

    // create a new object only with the filled in form values
    for (const [key, value] of formData) {
      if (value != '') {
        filteredFormData[key] = value;
      }
    }

    // trigger Product form submission on recipient form submit and send the additional form values
    const submitEvent = new CustomEvent('submit', { 'detail': { additionalFormData: filteredFormData }});
    this.productForm.querySelector('form').dispatchEvent(submitEvent);

  }

}

if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', RecipientForm);
}